import React from 'react'
import { Tag } from 'antd'
import { DeploymentUnitOutlined } from '@ant-design/icons'

const ProjectTag = ({ name, ...props }) => (
  <Tag color={'volcano'} icon={<DeploymentUnitOutlined />} {...props}>
    {name}
  </Tag>
)

export default ProjectTag
